import { render, staticRenderFns } from "./ConfirmRelatorioModal.vue?vue&type=template&id=2b0758ed&scoped=true"
import script from "./ConfirmRelatorioModal.vue?vue&type=script&lang=js"
export * from "./ConfirmRelatorioModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRelatorioModal.vue?vue&type=style&index=0&id=2b0758ed&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0758ed",
  null
  
)

export default component.exports